import { apiClient } from "./client";

export async function fetchCurrentUser() {
  const { data } = await apiClient.get("/auth/me/");
  return data;
}

export async function login({ email, password }) {
  const { data } = await apiClient.post("/auth/login/", { email, password });
  return data;
}

export async function logout() {
  await apiClient.post("/auth/logout/");
}

export async function updateProfile(changes) {
  const { data } = await apiClient.patch("/auth/me/", changes);
  return data;
}

export async function changePassword({ currentPassword, newPassword }) {
  await apiClient.post("/auth/password/change/", {
    current_password: currentPassword,
    new_password: newPassword,
  });
}

// ── Agency-scoped user management ─────────────────────────────────────────

export const orgUsersApi = {
  list: async ({ page = 1, search = "" } = {}) => {
    const params = { page };
    if (search) params.search = search;
    const { data } = await apiClient.get("/auth/org/users/", { params });
    return data;
  },

  get: async (id) => {
    const { data } = await apiClient.get(`/auth/org/users/${id}/`);
    return data;
  },

  invite: async (payload) => {
    const { data } = await apiClient.post("/auth/org/users/", payload);
    return data;
  },

  update: async (id, changes) => {
    const { data } = await apiClient.patch(`/auth/org/users/${id}/`, changes);
    return data;
  },
};
